import { useMemo } from 'react';
import uniqBy from 'lodash/uniqBy';
import {getFilteredRelatedFeatures, getRelatedFeaturesFromLayout} from "../../../../../../misc/helpers";
import workspace from "../../../canvas/core/workspace";

export const expandSearchText = (text) => {
  return (text || '')
    .replace(/\bh(\d)/gi, 'Height $1')
    .replace(/\bw(\d)/gi, 'Width $1')
    .replace(/\bd(\d)/gi, 'Depth $1')
    .replace(/\bh\b/gi, 'Height')
    .replace(/\bw\b/gi, 'Width')
    .replace(/\bd\b/gi, 'Depth');
};

export const toGridRow = (feature) => {
  return { part: feature };
};

const getRelatedFeaturesSafe = (parentFeature) => {
  if (!parentFeature) return [];
  const list =
    parentFeature.getFeatureRelatedFeature?.() ||
    parentFeature.getFeatureRelatedFeatures?.() ||
    [];
  return Array.isArray(list) ? list : [];
};

const buildVirtualPartId = ({ fallbackPartId, parentFeature }) => {
  return fallbackPartId || parentFeature?.partId || 'related';
};

export const useRelatedFeaturesProvider = ({
                                             enabled,
                                             featurePicker,
                                             fallbackPartId,
                                             searchText,
                                             selectedFilters,
                                           }) => {
  const shape = workspace.getShapeById(featurePicker.shapeId);

  return useMemo(() => {
    if (!enabled) {
      return { isLoading: false, headerPartId: fallbackPartId, featuresData: {} };
    }

    const parentFeature = shape?.getRelatedParentFeature?.();
    const relatedFeaturesRaw = getRelatedFeaturesSafe(parentFeature);
    const partId = buildVirtualPartId({ fallbackPartId, parentFeature });

    if (!parentFeature || relatedFeaturesRaw.length === 0) {
      return { isLoading: false, headerPartId: partId, featuresData: {} };
    }

    const expandedSearch = expandSearchText(searchText);

    const { relatedFeaturesFound } = getRelatedFeaturesFromLayout(
      relatedFeaturesRaw,
      parentFeature,
      expandedSearch,
      selectedFilters
    );

    let list = getFilteredRelatedFeatures(relatedFeaturesFound);
    list = uniqBy(list, (f) => f?.dbFeature?.id);

    const navItems = list.map(toGridRow);

    return {
      isLoading: false,
      headerPartId: partId,
      featuresData: {
        [partId]: {
          navItemsFromFeatureGroup: navItems,
          navItemsFromFeatureGroupFiltered: navItems,
          navItemsFromTheWizard: navItems,
          navItemsFromTheWizardFiltered: navItems,
          featureGroup: null,
        },
      },
    };
  }, [enabled, shape, fallbackPartId, searchText, selectedFilters]);
};
